import { render, staticRenderFns } from "./PartNumbers.vue?vue&type=template&id=24b5e73a&"
import script from "./PartNumbers.vue?vue&type=script&lang=js&"
export * from "./PartNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports